// GENERATED by scripts/sync-legal.py from the rushmore-social app's
// policy screens. Do not edit by hand — change the app, then re-run:
//   python3 scripts/sync-legal.py

export type LegalBlock = { type: 'heading' | 'paragraph'; text: string };

export type LegalDoc = {
  slug: string;
  title: string;
  effectiveDate: string | null;
  sourceScreen: string;
  blocks: LegalBlock[];
};

export const LEGAL_DOCS: LegalDoc[] = [
  {
    "slug": "terms",
    "title": "Terms of Service",
    "effectiveDate": "August 17, 2026",
    "sourceScreen": "TermsOfServiceScreen.tsx",
    "blocks": [
      {
        "type": "paragraph",
        "text": "By accessing or using Rushmore (the \"Application\"), you agree to be bound by these Terms of Service (the \"Terms\"). If you do not agree to these Terms, please do not use the Application. You must be at least 13 years old to use this Application."
      },
      {
        "type": "paragraph",
        "text": "These Terms include and incorporate our Privacy Policy, Community Guidelines, and Copyright & IP Policy. By using the Application, you agree to follow all of those policies."
      },
      {
        "type": "paragraph",
        "text": "When creating an account, you agree to provide accurate, current, and complete information. You are solely responsible for maintaining the confidentiality of your account and password and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security."
      },
      {
        "type": "paragraph",
        "text": "This Application allows users to post content, including opinions, lists, comments, likes, profile pictures, Rushmore item photos, and other materials (\"User Content\"). You are solely responsible for all User Content that you upload, post, or otherwise make available through the Application. You agree not to post any content that is illegal, harmful, defamatory, obscene, pornographic, graphically violent, abusive, infringing, or otherwise objectionable. You also agree not to use the Application to infringe on the intellectual property, privacy, publicity, or other rights of others."
      },
      {
        "type": "paragraph",
        "text": "User Content Rights and Permissions: By uploading or posting User Content, you represent and warrant that you own the User Content or have all rights, licenses, consents, releases, and permissions needed to upload it, display it in the Application, grant us the license in these Terms, and allow other users to view and interact with it as the Application permits. This includes rights in any photos, images, artwork, logos, screenshots, names, likenesses, trademarks, and other materials included in your User Content. You agree not to upload confidential information, non-consensual intimate imagery, or content that violates another person's rights or applicable law."
      },
      {
        "type": "paragraph",
        "text": "Public Interactions: Certain features of the Application are designed for public or social interaction. Comments, likes, usernames, profile information displayed in the Application, timestamps, and related engagement activity may be visible to other users of the Application. You should only post comments and use public features with content, opinions, and information that you are comfortable sharing within the Rushmore experience. Do not post confidential, sensitive, or private personal information in comments or other public areas of the Application."
      },
      {
        "type": "paragraph",
        "text": "Prohibited Activities: You agree not to engage in any of the following prohibited activities:\n- Using the Application for any unlawful or fraudulent purpose.\n- Impersonating any person or entity or falsely stating or misrepresenting your affiliation with a person or entity.\n- Uploading, posting, or transmitting any content that you do not have a right to make available under any law or contractual obligation.\n- Using any automated means, including bots, scrapers, or crawlers, to access or use the Application without our express permission.\n- Interfering with or disrupting the Application or servers or networks connected to the Application."
      },
      {
        "type": "paragraph",
        "text": "Security & Platform Integrity: You agree not to:\n- Upload or transmit malware (viruses, trojans, worms) or anything intended to damage, disrupt, or gain unauthorized access.\n- Attempt to hack or bypass security, or probe, scan, or test vulnerabilities (unless you have written permission).\n- Tamper with requests or parameters, use modified clients, intercept traffic, automate abusive calls, or attempt to manipulate counts, rankings, comment likes, tokens, ads, or moderation systems.\n- Circumvent content filters, including deliberate obfuscation to evade profanity or moderation."
      },
      {
        "type": "paragraph",
        "text": "Content and Conduct: You agree not to:\n- Spam, harass, or engage in hateful or threatening behavior, or post sexual content involving minors.\n- Post pornography, graphic gore, or content intended primarily to shock, exploit, or abuse others.\n- Post comments or content containing private or confidential information about yourself or another person in public areas of the Application.\n- Artificially inflate or coordinate engagement, including comment likes or other forms of inauthentic activity."
      },
      {
        "type": "paragraph",
        "text": "Moderation and No Endorsement: We may use automated tools, human review, user reports, and other measures to detect or respond to content or conduct that may violate these Terms, our Community Guidelines, or applicable law. We do not guarantee that all User Content will be reviewed before it appears in the Application, and we do not endorse, verify, or assume responsibility for User Content posted by users. You may be exposed to content that is inaccurate, objectionable, or inappropriate."
      },
      {
        "type": "paragraph",
        "text": "You retain ownership of any User Content you post on the Application. However, by posting User Content, you grant PTOA LLC a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable right to host, store, cache, process, analyze, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, publicly display, and otherwise use such User Content throughout the world in any media for the purpose of operating, improving, promoting, protecting, and providing the Application. This includes creating image variants, thumbnails, previews, backups, and CDN copies, and displaying your username, profile information, and related activity with your User Content where the Application does so."
      },
      {
        "type": "paragraph",
        "text": "Copyright and Intellectual Property Complaints: We respect the intellectual property rights of others. If we receive a valid copyright or intellectual property complaint, we may remove or disable access to the reported content, notify the user who posted it, process a counter-notification where applicable, and take action against repeat infringers. Our Copyright & IP Policy explains how to submit copyright and intellectual property reports and is incorporated into these Terms. Copyright notices may be sent to PTOA LLC Copyright Agent at support@ptoallc.com."
      },
      {
        "type": "paragraph",
        "text": "All intellectual property rights in the Application, including but not limited to software, design, text, graphics, and trademarks, are owned by PTOA LLC or its licensors. You agree not to copy, modify, or distribute any part of the Application without our prior written consent."
      },
      {
        "type": "paragraph",
        "text": "Rushmore Social is monetized through in-app advertising and in-app purchases. Ads may appear as full-screen interstitials or as rewarded video ads that provide tokens/coins or other in-app benefits when voluntarily watched. These advertisements are clearly marked and are not required to use the Application. We do not offer an ad-free version of the Application at this time.\n\nIn-App Purchases & Slots\n- You may purchase additional Rushmore build slots (“Slots”) or individual Rushmores to build.\n- All purchases are final and non-refundable. You cannot obtain a refund simply by choosing not to build a Rushmore or by deleting a Rushmore for which you purchased a Slot.\n- Purchased Slots remain yours. Even if you delete a Rushmore or never use a Slot immediately, that Slot will remain available in your account for future use. Should you return to build or edit a Rushmore at any time, your previously purchased Slot(s) will still be active.\n- Slots cannot be sold back, exchanged, transferred, or otherwise converted into any form of credit or refund."
      },
      {
        "type": "paragraph",
        "text": "The Application provides users with curated lists of items, such as professional football teams, players, and other entities, from which they can create their own lists or express opinions. These lists are curated by PTOA LLC and are intended solely for user interaction and opinion sharing. The use of trademarked names within these lists is strictly for identification purposes and does not imply any endorsement or affiliation with PTOA LLC. The opinions expressed are solely those of the users and do not reflect the views of PTOA LLC. The Application does not promote or advocate any opinions expressed by users, and such content should not be construed as advertising or promoting any product, service, or individual. The inclusion of names, teams, players, brands, public figures, or other items in curated lists does not give users permission to upload third-party photos, logos, artwork, screenshots, or other protected content."
      },
      {
        "type": "paragraph",
        "text": "The Application allows users to select and display items from provided lists. Please note that these lists may not be comprehensive and may not include all possible items. We are not liable for any omissions or the inability to find specific items within these lists. The data presented in the Application is merely a suggestion, and users should independently verify the information."
      },
      {
        "type": "paragraph",
        "text": "We respect your privacy and will only collect and use your personal information as outlined in our Privacy Policy, which is incorporated into these Terms by reference. By using the Application, you agree to the collection and use of your information as described in the Privacy Policy."
      },
      {
        "type": "paragraph",
        "text": "Enforcement: We may enforce these Terms in our sole discretion, including removing content or comments, limiting reach or visibility, removing abusive or inauthentic engagement, closing comment threads, issuing warnings or strikes, suspending or terminating accounts, and reporting activity to law enforcement or other authorities where appropriate. Repeat offenders may face escalating enforcement, up to permanent suspension."
      },
      {
        "type": "paragraph",
        "text": "Indemnification: To the fullest extent permitted by law, you agree to defend, indemnify, and hold harmless PTOA LLC and its owners, employees, contractors, service providers, licensors, and affiliates from and against any claims, damages, losses, liabilities, costs, and expenses, including reasonable attorneys' fees, arising out of or related to your User Content, your use of the Application, your violation of these Terms or our policies, or your violation of any law or third-party right, including copyright, trademark, privacy, or publicity rights."
      },
      {
        "type": "paragraph",
        "text": "To the fullest extent permitted by law, PTOA LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:\n- Your use of or inability to use the Application.\n- Any unauthorized access to or use of our servers and/or any personal information stored therein.\n- Any interruption or cessation of transmission to or from the Application.\n- Any User Content or conduct of any user or third party on or through the Application."
      },
      {
        "type": "paragraph",
        "text": "These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts located in Florida for the resolution of any disputes arising out of or related to these Terms or the Application."
      },
      {
        "type": "paragraph",
        "text": "We may modify these Terms at any time. If we do so, we will notify you by posting the updated Terms on the Application and updating the \"Effective Date\" at the top of the page. Your continued use of the Application after any changes to these Terms constitutes your acceptance of the new Terms."
      },
      {
        "type": "paragraph",
        "text": "If you have any questions or concerns about these Terms, please contact us at support@ptoallc.com."
      }
    ]
  },
  {
    "slug": "community-guidelines",
    "title": "Community Guidelines",
    "effectiveDate": "August 17, 2026",
    "sourceScreen": "CommunityGuidelinesScreen.tsx",
    "blocks": [
      {
        "type": "paragraph",
        "text": "Rushmore is a place to share opinions, ranked lists, and public discussion. To keep the community safe and enjoyable, you must follow these Community Guidelines whenever you use the app, post content, comment, like content, message, or upload images."
      },
      {
        "type": "heading",
        "text": "1) Be respectful"
      },
      {
        "type": "paragraph",
        "text": "Do not post or engage in:\n- Harassment, bullying, intimidation, or targeted abuse.\n- Hate speech or hateful content targeting protected groups.\n- Threats of violence, encouragement of self-harm, or glorifying violence.\n- Doxxing or sharing someone's private personal information."
      },
      {
        "type": "heading",
        "text": "2) Public comments and interactions"
      },
      {
        "type": "paragraph",
        "text": "Comments and comment likes are public within the Rushmore experience and may be visible to other users along with your username and related account information shown in the app. Only post comments or engage in public features with information and opinions you are comfortable sharing with others in the Application."
      },
      {
        "type": "paragraph",
        "text": "Do not post in comments:\n- Phone numbers, home addresses, email addresses, financial information, medical information, or other confidential or sensitive personal information.\n- Private information about yourself or another person that does not belong in a public discussion."
      },
      {
        "type": "heading",
        "text": "3) No illegal or harmful content"
      },
      {
        "type": "paragraph",
        "text": "Do not use Rushmore to post, request, or promote:\n- Illegal activity (including buying/selling illegal goods or services).\n- Instructions to commit wrongdoing or evade law enforcement.\n- Content that encourages harm to people, animals, or property.\n- Graphic gore, real-world violence, or shocking imagery posted for abuse, harassment, or shock value."
      },
      {
        "type": "heading",
        "text": "4) Sexual content and safety"
      },
      {
        "type": "paragraph",
        "text": "Do not post or share:\n- Sexual exploitation of any kind.\n- Content involving minors in a sexual context (this results in immediate enforcement and may be reported).\n- Non-consensual intimate imagery.\n- Pornography, explicit nudity, or graphic sexual content."
      },
      {
        "type": "heading",
        "text": "5) No spam or manipulation"
      },
      {
        "type": "paragraph",
        "text": "Do not:\n- Post spam, repetitive content, or deceptive links.\n- Post repetitive, low-quality, or copy-pasted comments to flood discussions.\n- Coordinate fake engagement (likes, follows, comments) or attempt to manipulate rankings, counts, or visibility.\n- Use bots or automation to abuse features."
      },
      {
        "type": "heading",
        "text": "6) No impersonation or deception"
      },
      {
        "type": "paragraph",
        "text": "Do not:\n- Pretend to be someone else, a public figure, or an employee/representative of PTOA LLC.\n- Misrepresent your identity to mislead, scam, or harass others."
      },
      {
        "type": "heading",
        "text": "7) Platform integrity and security"
      },
      {
        "type": "paragraph",
        "text": "Do not:\n- Upload malware or harmful files.\n- Attempt to hack, exploit, or probe the app or backend systems.\n- Tamper with requests or parameters, use modified clients, intercept traffic, or bypass protections.\n- Circumvent filters or evade moderation (including intentional obfuscation)."
      },
      {
        "type": "heading",
        "text": "8) Respect intellectual property"
      },
      {
        "type": "paragraph",
        "text": "Only post content you have the right to share. Do not infringe copyrights, trademarks, or other rights."
      },
      {
        "type": "paragraph",
        "text": "For item photos and profile pictures, do not upload third-party photos, team or league logos, screenshots, artwork, or other protected images unless you created them, own them, have permission to use them, or are otherwise legally allowed to post them. A Rushmore list may mention a team, player, brand, public figure, or other item for identification, but that does not give you rights to upload someone else's protected image."
      },
      {
        "type": "heading",
        "text": "9) Reporting and what happens next"
      },
      {
        "type": "paragraph",
        "text": "If you see content or behavior that violates these guidelines, report it in the app or contact support at support@ptoallc.com."
      },
      {
        "type": "paragraph",
        "text": "When we receive a report (or detect a violation), we may:\n- Remove or limit visibility of content or comments.\n- Remove likes or engagement we believe are abusive, inauthentic, or manipulated.\n- Close comment threads or limit commenting features.\n- Issue warnings.\n- Temporarily limit features.\n- Suspend or terminate accounts.\n- Report activity to authorities when required or appropriate."
      },
      {
        "type": "paragraph",
        "text": "Enforcement is based on severity, context, and history of behavior."
      },
      {
        "type": "heading",
        "text": "10) These Guidelines are part of our Terms"
      },
      {
        "type": "paragraph",
        "text": "These Community Guidelines are enforced under our Terms of Service, and continued use of Rushmore means you agree to follow them."
      }
    ]
  },
  {
    "slug": "copyright",
    "title": "Copyright & IP Policy",
    "effectiveDate": "August 17, 2026",
    "sourceScreen": "CopyrightPolicyScreen.tsx",
    "blocks": [
      {
        "type": "paragraph",
        "text": "PTOA LLC respects the intellectual property rights of others and expects Rushmore users to do the same. This Copyright and Intellectual Property Policy applies to photos, profile pictures, Rushmore item images, comments, lists, rankings, and all other content submitted to the Application."
      },
      {
        "type": "heading",
        "text": "1. User Responsibility"
      },
      {
        "type": "paragraph",
        "text": "You may upload or post content only if you own it, created it, have permission to use it, or are otherwise legally allowed to use it. Do not upload copyrighted photos, screenshots, logos, artwork, videos, graphics, or other protected material unless you have the necessary rights or a valid legal basis to do so."
      },
      {
        "type": "heading",
        "text": "2. Reporting Copyright Infringement"
      },
      {
        "type": "paragraph",
        "text": "If you are a copyright owner or authorized to act on behalf of one and believe content on Rushmore infringes your copyright, send a written notice to:\n\nPTOA LLC Copyright Agent\nEmail: support@ptoallc.com"
      },
      {
        "type": "paragraph",
        "text": "Your notice should include:\n- Your physical or electronic signature.\n- Identification of the copyrighted work claimed to be infringed.\n- Identification of the material you claim is infringing and information reasonably sufficient for us to locate it in the Application.\n- Your contact information, including your name, mailing address, phone number, and email address.\n- A statement that you have a good faith belief that use of the material is not authorized by the copyright owner, its agent, or the law.\n- A statement, made under penalty of perjury, that the information in the notice is accurate and that you are the copyright owner or authorized to act on behalf of the owner."
      },
      {
        "type": "paragraph",
        "text": "We may reject or be unable to process notices that are incomplete, unclear, fraudulent, or not submitted by the copyright owner or an authorized representative. We may remove or disable access to content that is alleged to infringe copyright, and we may notify the user who posted the content."
      },
      {
        "type": "heading",
        "text": "3. Counter-Notifications"
      },
      {
        "type": "paragraph",
        "text": "If content you posted is removed or disabled because of a copyright notice and you believe the removal was a mistake or misidentification, you may send us a written counter-notification. Your counter-notice should include:\n- Your physical or electronic signature.\n- Identification of the removed content and where it appeared.\n- A statement under penalty of perjury that you have a good faith belief the content was removed or disabled by mistake or misidentification.\n- Your name, mailing address, phone number, and email address.\n- A statement that you consent to the jurisdiction of the appropriate federal court and will accept service of process from the person who submitted the original notice or that person's agent."
      },
      {
        "type": "paragraph",
        "text": "We may forward your counter-notification, including your contact information, to the person who submitted the original copyright notice. We may restore disabled content where appropriate under applicable law unless the copyright claimant notifies us that they have filed a court action seeking to keep the content disabled."
      },
      {
        "type": "heading",
        "text": "4. Repeat Infringers"
      },
      {
        "type": "paragraph",
        "text": "PTOA LLC may, in appropriate circumstances and at its discretion, disable content, limit features, suspend accounts, or terminate accounts of users who repeatedly infringe or are repeatedly accused of infringing copyrights, trademarks, or other intellectual property rights. Severe violations may result in immediate enforcement."
      },
      {
        "type": "heading",
        "text": "5. Trademark and Other Rights"
      },
      {
        "type": "paragraph",
        "text": "If you believe content on Rushmore violates your trademark, publicity, privacy, or other legal rights, contact us at support@ptoallc.com with enough detail for us to locate and review the content. We may remove, restrict, or take other action on content that violates our Terms, Community Guidelines, this policy, or applicable law."
      },
      {
        "type": "heading",
        "text": "6. False or Bad-Faith Claims"
      },
      {
        "type": "paragraph",
        "text": "Submitting false, misleading, or bad-faith notices or counter-notifications may result in legal liability and may lead to account enforcement. PTOA LLC is not in a position to adjudicate every dispute between users and rights holders, and rights holders and users may have other legal remedies."
      }
    ]
  },
  {
    "slug": "privacy",
    "title": "Privacy Policy",
    "effectiveDate": "August 17, 2026",
    "sourceScreen": "PrivacyPolicyScreen.tsx",
    "blocks": [
      {
        "type": "paragraph",
        "text": "PTOA LLC (\"we,\" \"us,\" or \"our\") respects your privacy and is committed to protecting the personal information that you share with us through the Rushmore mobile application (the \"Application\"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the Application. By accessing or using the Application, you agree to this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not access or use the Application."
      },
      {
        "type": "heading",
        "text": "1. Information We Collect"
      },
      {
        "type": "paragraph",
        "text": "We may collect personal and non-personal information about you in the following ways:"
      },
      {
        "type": "paragraph",
        "text": "- Account Information: When you create an account, we collect your username, email address, date of birth, and any other information you choose to provide."
      },
      {
        "type": "paragraph",
        "text": "- User Content and Social Activity: We collect information you submit or generate in the Application, including lists, rankings, comments, likes, comment likes, reports, uploaded images, and other content or interactions you choose to make available through the Application. Uploaded images may include profile pictures and Rushmore item photos, along with related technical information such as file size, media type, upload status, image dimensions, generated previews, and moderation results."
      },
      {
        "type": "paragraph",
        "text": "- Usage Data: We may collect information about how you interact with the Application, including the features you use, the content you view, the content you engage with, and the actions you take within the Application."
      },
      {
        "type": "paragraph",
        "text": "- Device Information: We may collect information about the device you use to access the Application, such as your device type, operating system, unique device identifier, and IP address."
      },
      {
        "type": "paragraph",
        "text": "- Location Data: With your consent, we may collect information about your device’s location to provide location-based services."
      },
      {
        "type": "paragraph",
        "text": "- Advertising: We use third-party advertising services (e.g. Google AdMob) to display ads within the Application. These may include interstitial ads and rewarded ads that offer in-app rewards when voluntarily viewed. These services may collect device identifiers (including Apple’s IDFA if you allow tracking), location data (if granted), and analytics data to serve ads that may be relevant to your interests (“personalized ads”).\n\n- App Tracking Transparency (iOS): On iOS 14 and above, we will ask for your permission before tracking you across apps and websites. If you decline, we will display only non-personalized ads that do not use your IDFA. You can change your decision at any time by navigating to Settings → Rushmore Mobile → Tracking.\n\n- California Privacy Rights (CCPA/CPRA): If you live in California, you may have rights regarding your personal information, including the right to request access, deletion, and to opt out of certain data sharing for targeted advertising, as applicable by law.\n\n- Children Under 13: This Application is not intended for use by children under 13, and we do not knowingly collect personal information from anyone under 13.\n\n- Data Collected for Ads: Depending on your permissions and how you use the Application, ad partners may receive device and analytics information to support ad delivery, measurement, fraud prevention, and related services."
      },
      {
        "type": "heading",
        "text": "2. How We Use Your Information"
      },
      {
        "type": "paragraph",
        "text": "We use the information we collect for the following purposes:"
      },
      {
        "type": "paragraph",
        "text": "- To Provide and Improve the Application: We use your information to operate, maintain, and enhance the Application's functionality and user experience."
      },
      {
        "type": "paragraph",
        "text": "- To Communicate with You: We may use your contact information to send you updates, notifications, and other information related to your use of the Application."
      },
      {
        "type": "paragraph",
        "text": "- To Personalize User Experience: We may use your information to personalize your experience within the Application, such as displaying content tailored to your interests."
      },
      {
        "type": "paragraph",
        "text": "- To Facilitate Transactions: If you make a purchase within the Application, we use your information to process and complete the transaction."
      },
      {
        "type": "paragraph",
        "text": "- To Moderate and Enforce Rules: We may use content, comments, likes, reports, uploaded images, media metadata, and related engagement data to review safety issues, investigate abuse, enforce our Terms, Community Guidelines, and Copyright & IP Policy, prevent spam or manipulation, process intellectual property complaints, and protect the integrity of the Application."
      },
      {
        "type": "paragraph",
        "text": "- To Ensure Compliance: We use your information to enforce our Terms of Service and comply with legal obligations."
      },
      {
        "type": "paragraph",
        "text": "- User-Generated Content: The Application offers users a predefined set of categories—such as sports, entertainment, music, gaming, public figures, travel destinations, dining, holidays, and more—from which to build their own custom lists. Users may submit rankings, reviews, comments, and other opinions about any item provided. All submissions remain the intellectual property of their creators, subject to the license granted in our Terms of Service, and do not represent the views, endorsements, or sponsorships of PTOA LLC."
      },
      {
        "type": "heading",
        "text": "3. Visibility of Content and Interactions"
      },
      {
        "type": "paragraph",
        "text": "Certain features of the Application are social and intended to be visible to other users. If you upload item photos, profile pictures, post comments, like content, or like comments, that content or activity may be visible within the Rushmore experience to other users, together with your username, profile information shown in the app, timestamps, and related content context."
      },
      {
        "type": "paragraph",
        "text": "Please do not submit sensitive personal information, confidential information, or private information in comments or other public areas of the Application. Content and interactions you choose to make public or submit in public-facing features may be viewed by others in the Application."
      },
      {
        "type": "paragraph",
        "text": "Uploaded images that you attach to published Rushmores may be displayed to other users and may be stored, cached, transformed, or delivered through media hosting, content delivery, image processing, and moderation systems. If you do not want an image to be visible to other users, do not upload or publish it in a public-facing feature."
      },
      {
        "type": "heading",
        "text": "4. Sharing Your Information"
      },
      {
        "type": "paragraph",
        "text": "We do not sell or rent your personal information to third parties. However, we may share your information in the following circumstances:"
      },
      {
        "type": "paragraph",
        "text": "- With Service Providers: We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, hosting, media storage, content delivery networks, image processing, advertising, content moderation, fraud prevention, and customer support. This includes product analytics and session replay services (e.g., PostHog) used to understand how the Application is used and improve user experience."
      },
      {
        "type": "paragraph",
        "text": "- For Legal Reasons: We may disclose your information if required to do so by law or if we believe such action is necessary to comply with legal obligations, process copyright or intellectual property notices and counter-notices, protect our rights, enforce our Terms or policies, or prevent fraud, abuse, or illegal activity."
      },
      {
        "type": "paragraph",
        "text": "- In Connection with Business Transfers: In the event of a merger, acquisition, or sale of all or part of our assets, your information may be transferred as part of that transaction."
      },
      {
        "type": "heading",
        "text": "5. Your Choices"
      },
      {
        "type": "paragraph",
        "text": "You have the following options regarding your information:"
      },
      {
        "type": "paragraph",
        "text": "- Access and Update: You can access and update your account information within the Application."
      },
      {
        "type": "paragraph",
        "text": "- Opt-Out: You may opt out of receiving promotional communications from us by following the unsubscribe instructions in those communications."
      },
      {
        "type": "paragraph",
        "text": "- Location Data: You can control the collection of location data through your device settings."
      },
      {
        "type": "paragraph",
        "text": "- Data Deletion: You can request the deletion of your account and personal information by deleting your account in account settings, or by contacting support where applicable."
      },
      {
        "type": "heading",
        "text": "6. Data Retention"
      },
      {
        "type": "paragraph",
        "text": "We retain information for as long as reasonably necessary to provide the Application, maintain security, enforce our Terms and policies, comply with legal obligations, resolve disputes, and protect our rights and users. Removed content, including uploaded images, may remain for a limited time in backups, logs, caches, moderation records, fraud or abuse records, legal records, or copyright and intellectual property notice records where permitted or required by law."
      },
      {
        "type": "heading",
        "text": "7. Security"
      },
      {
        "type": "paragraph",
        "text": "We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no data transmission over the internet or wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your information, you acknowledge that there are security and privacy limitations inherent to the internet that are beyond our control."
      },
      {
        "type": "heading",
        "text": "8. Children’s Privacy"
      },
      {
        "type": "paragraph",
        "text": "The Application is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have inadvertently collected personal information from a child under 13, we will take steps to delete such information as soon as possible. Parents or guardians who believe a child under 13 has provided personal information may contact us at support@ptoallc.com to request deletion."
      },
      {
        "type": "heading",
        "text": "9. Changes to This Privacy Policy"
      },
      {
        "type": "paragraph",
        "text": "We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. If we make material changes, we will notify you by updating the \"Effective Date\" at the top of this policy and, if required by law, providing additional notice. Your continued use of the Application after any changes to this Privacy Policy constitutes your acceptance of the updated policy."
      },
      {
        "type": "heading",
        "text": "10. Contact Us"
      },
      {
        "type": "paragraph",
        "text": "If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at support@ptoallc.com."
      }
    ]
  }
];
